module.exports = __webpack_public_path__ + "img/manage.3d5ead3.svg";